const Footer = () => (
  <footer className="border-t border-line py-12">
    <div className="mx-auto max-w-6xl px-6">
      <div className="flex flex-col justify-between gap-10 sm:flex-row">
        <div>
          <span className="font-mono text-lg font-semibold tracking-tight">
            techlyft<span className="text-accent">_</span>
          </span>
          <p className="mt-3 max-w-xs text-sm text-muted">
            A product &amp; software engineering studio in Sydney, Australia.
          </p>
        </div>
        <div className="flex gap-16">
          <div>
            <h3 className="font-mono text-xs uppercase tracking-widest text-muted">
              Products
            </h3>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <a
                  href="https://metrifly.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted transition-colors hover:text-fg"
                >
                  Metrifly
                </a>
              </li>
              <li>
                <a
                  href="https://desknova.io"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted transition-colors hover:text-fg"
                >
                  DeskNova
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-mono text-xs uppercase tracking-widest text-muted">
              Contact
            </h3>
            <ul className="mt-4 space-y-2 text-sm text-muted">
              <li>
                <a
                  href="mailto:hello@techlyft.com"
                  className="transition-colors hover:text-fg"
                >
                  hello@techlyft.com
                </a>
              </li>
              <li>16 Myles Crescent, North Kellyville, NSW 2155</li>
            </ul>
          </div>
        </div>
      </div>
      <p className="mt-12 border-t border-line pt-8 text-center text-sm text-muted">
        &copy; {new Date().getFullYear()} Techlyft Pty Ltd (ABN: 32635864970).
        All rights reserved.
      </p>
    </div>
  </footer>
);

export default Footer;
